<template>
  <v-container>
    <v-row>
      <v-col cols="4" class="d-flex justify-start" style="font-size: 1.6em">
        <v-icon size="30" color="green">mdi-menu-up</v-icon> Ingresos:
        {{ new Intl.NumberFormat("es-VE").format(balanceIn) }} S/
      </v-col>
      <v-col cols="4" class="d-flex justify-center" style="font-size: 1.6em">
        <v-icon size="30" color="red">mdi-menu-down</v-icon> Egresos:
        {{ new Intl.NumberFormat("es-VE").format(balanceOut) }} S/
      </v-col>
      <v-col
        cols="4"
        class="d-flex justify-end"
        style="font-size: 1.6em; font-weight: bold"
      >
        {{ schema == "closed" ? "Entregado: " : "Saldo: " }}
        {{ new Intl.NumberFormat("es-VE").format(balance) }} S/
      </v-col>
      <v-col>
        <v-list>
          <v-list-item-group color="primary">
            <template v-for="(mov, key) in movements">
              <v-list-item :key="key" @click="openDialogMovement(mov)">
                <v-list-item-title class="mt-2 mb-2"
                  >{{ mov.description }}
                  <v-list-item-subtitle
                    :style="mov.type == 1 ? 'color: green' : 'color: red'"
                  >
                    {{ mov.type == 1 ? "INGRESO" : "EGRESO" }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ mov.created_at }}
                  </v-list-item-subtitle>
                </v-list-item-title>
                <v-list-item-action>
                  <span :style="mov.type == 1 ? 'color: green' : 'color: red'">
                    {{ new Intl.NumberFormat("es-VE").format(mov.amount) }}
                  </span>
                </v-list-item-action>
              </v-list-item>
              <v-divider
                :key="`div${key}`"
                v-if="key != movements.length - 1"
              />
            </template>
          </v-list-item-group>
        </v-list>
      </v-col>
    </v-row>

    <!-- <v-dialog v-model="dialogMovement" width="800" persistent>
      <v-card>
        <v-card-text>
          <movements
            schema="show"
            :movement="movement"
            @closeDialogMovement="closeDialogMovement"
            @deleteMovement="deleteMovement"
          />
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
//import Movements from "../../views/Movements/Movements.vue";

export default {
  //components: { Movements },
  props: ["movements", "schema"],

  mounted() {
    //this.findBalance();
  },

  data() {
    return {
      loadingBalance: true,
      dialogMovement: false,
      movement: null,
    };
  },

  computed: {
    balance() {
      if (this.movements) {
        let total = 0;
        for (let key in this.movements) {
          total += this.movements[key].amount;
        }
        return total;
      } else {
        return 0;
      }
    },

    balanceIn() {
      if (this.movements.length > 0) {
        let total = 0;
        for (let key in this.movements) {
          if (this.movements[key].type == 1)
            total += this.movements[key].amount;
        }
        return total;
      } else {
        return 0;
      }
    },

    balanceOut() {
      if (this.movements.length > 0) {
        let total = 0;
        for (let key in this.movements) {
          if (this.movements[key].type == 2)
            total += this.movements[key].amount;
        }
        return total * -1;
      } else {
        return 0;
      }
    },
  },

  methods: {
    openDialogMovement(mov) {
      if (this.schema == "closed") return;

      this.dialogMovement = true;
      this.movement = mov;
    },

    closeDialogMovement() {
      this.dialogMovement = false;
    },

    deleteMovement(movement) {
      let index = this.movements.findIndex((m) => m.id == movement.id);
      this.movements.splice(index, 1);
      this.dialogMovement = false;
    },
  },
};
</script>

<style></style>
